// 로그인 필드명 리스트
export const AuthAttributes = Object({
  userId: '아이디',
  password: '비밀번호',
})